<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        :rules="rules"
        ref="ruleForm"
      >
        <a-form-model-item label="Price">
          <a-input-number
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
            :min="0"
            v-model="form.price"
            placeholder="Enter text..."
            style="width: 100%;"
          />
        </a-form-model-item>
        <a-form-model-item label="Name">
          <a-input v-model="form.model" placeholder="Enter text..." />
        </a-form-model-item>
      </a-form-model>
      <a-divider orientation="left">
        INFORMATION
      </a-divider>
      <a-descriptions :column="1">
        <a-descriptions-item label="Author">
          {{ form.author && (form.author.fullname || form.author.username) }}
        </a-descriptions-item>
        <a-descriptions-item label="Created At">
          {{ form.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Updated At">
          {{ form.updatedAt | formatDateHour }}
        </a-descriptions-item>
      </a-descriptions>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Confirm action?"
          ok-text="Delete"
          cancel-text="No"
          @confirm="onDeletedVehicleType"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left;"
            :loading="loadingBtn"
          >
            Delete
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" @click="close">
          Close
        </a-button>
        <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
          Update
        </a-button>
      </div>
    </div>
  </a-skeleton>
</template>
<script>
import query from "../constant/query";
// components

const rules = {
  title: [{ required: true, message: "Required" }],
};
export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    idVehicleType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
      loadingBtn: false,
    };
  },
  methods: {
    setFormItem(nameForm, value) {
      this.$set(this.form, nameForm, value);
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdatedVehicleType();
        } else {
          return false;
        }
      });
    },
    onUpdatedVehicleType() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateVehicleType,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Update success!",
          });
          this.loadingBtn = false;
          if (data?.updateVehicleType?.id) {
            this.refreshAfterUpdated(data.updateVehicleType);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Update error!",
          });
          console.error("Cập nhật khách hàng không thành công", err);
        });
    },
    onGetVehicleType() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getDetailVehicleType,
          variables: { id: this.idVehicleType },
        })
        .then(({ data }) => {
          this.loading = false;
          if (data?.getDetailVehicleType?.id) {
            this.vehicleType = { ...data.getDetailVehicleType };
            this.form = { ...data.getDetailVehicleType };
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Get info error!",
          });
          console.error("Lấy chi tiết không thành công", err);
        });
    },
    onDeletedVehicleType() {
      if (this?.form?.id) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteVehicleType,
            variables: {
              id: this.form.id,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Success",
              description: "Delete success!",
            });
            this.loadingBtn = false;
            if (data?.deleteVehicleType?.id) {
              this.refreshAfterDeleted(data.deleteVehicleType);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Error",
              description: "Delete error!",
            });
            console.error("Xóa khách hàng không thành công", err);
          });
      }
    },
  },
  created() {
    this.onGetVehicleType();
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
